import { Component, OnInit } from '@angular/core';
import { ElectionService } from 'src/app/services/election.service';

@Component({
  selector: 'app-test-live',
  templateUrl: './test-live.component.html',
  styleUrls: ['./test-live.component.scss']
})
export class TestLiveComponent implements OnInit {

  constructor(public electionService: ElectionService) { 
    electionService.isTestingMode = true;
  }

  ngOnInit(): void {
  }

}
